import { Heading } from "./NKDaily";

export default function Settings() {
  return (
    <div className="space-y-6">
      <Heading title="Settings" subtitle="Platform-wide configuration. Most live values are read from environment — change them in deploy." />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card title="League rules">
          <Row k="Season length" v="30 days" />
          <Row k="Day length" v="24h (configurable per-season)" />
          <Row k="Country War" v="NG vs GH" />
          <Row k="Knowledge Rating model" v="ELO · K=32 · seeded at 1000" />
        </Card>
        <Card title="Mode timings">
          <Row k="NK Daily" v="15 questions · 15s per Q · 6s reveal" />
          <Row k="NK Ladder" v="Every 30 min · 8am–8pm UTC · 15 rungs" />
          <Row k="NK Duel" v="Gate Q 30s · 5 questions per side" />
          <Row k="NK Survival" v="20s per Q · base +5 SS · combo every 5 · milestones 10/25/50/100" />
        </Card>
        <Card title="Championship">
          <Row k="Format" v="4 rounds · 5 questions each" />
          <Row k="Lives" v="Seed #1=3 · #2-3=2 · #4-10=1" />
          <Row k="Elimination rule" v="Bottom-quartile loses a life per round" />
        </Card>
        <Card title="Monetization">
          <Row k="Entry fees" v="None — free to play, always" />
          <Row k="NK+ price (planned)" v="$5 / month" />
          <Row k="Payouts" v="Direct to bank or mobile money · no wallet" />
        </Card>
      </div>
      <p className="text-[11px] text-nk-dim">More controls (sponsor caps, automation toggles, KYC providers) ship as ops needs surface.</p>
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div className="nk-card p-4">
      <p className="eyebrow mb-3">{title}</p>
      <div className="space-y-2">{children}</div>
    </div>
  );
}
function Row({ k, v }) {
  return (
    <div className="flex justify-between gap-3 text-sm">
      <span className="text-nk-mute">{k}</span>
      <span className="text-right">{v}</span>
    </div>
  );
}
